'use client';
import styled from 'styled-components';
import { Card } from '@/ui/primatives';
import { colors, breakPoints } from '@/styles';

export const ModelInfo = styled(Card)`
  display: flex;
  flex-direction: column;
  background-color: ${colors.secondary.lightGray1};
  padding: 20px;

  label {
    font-weight: 600;
  }
  p {
    margin-top: 0px;
    line-height: 1.5;
  }
  .developer-logo {
    height: 18px;
    min-width: 18px;
  }
`;
